export default __webpack_public_path__ + "static/tiempos-text-web-medium-84a35a487e48a5388dd93a2a9fa01efd.woff";